import { context, trace } from '@opentelemetry/api';
import { ATTR_MULTIPLAYER_CONTINUOUS_SESSION_AUTO_SAVE, ATTR_MULTIPLAYER_CONTINUOUS_SESSION_AUTO_SAVE_REASON, } from '../constants/constants.base';
/**
 * @description Set auto save attribute to span
 * @param {String} reason
 * @returns {void}
 */
export var saveContinuousSession = function (reason) {
    var span = trace.getSpan(context.active());
    if (!span) {
        return;
        // create span
    }
    span === null || span === void 0 ? void 0 : span.setAttribute(ATTR_MULTIPLAYER_CONTINUOUS_SESSION_AUTO_SAVE, true);
    if (reason === null || reason === void 0 ? void 0 : reason.length) {
        span === null || span === void 0 ? void 0 : span.addEvent(ATTR_MULTIPLAYER_CONTINUOUS_SESSION_AUTO_SAVE_REASON, {
            reason: reason,
        });
    }
};
//# sourceMappingURL=save-continuous-deb-session.js.map